module.exports = __webpack_public_path__ + "static/media/item_1_8_comp.1b60426e.png";